import { useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const DataProtection = ({
  title = "Protection des données à caractère personnel",
  text,
  paragraphs = [
    "Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016, et à la Loi « Informatique et Libertés » n°78-17 du 6 janvier 1978 modifiée, Acoris vous informe que vos informations personnelles font l'objet d'un traitement. En tant que responsable de traitement, Acoris les utilise pour préparer votre dossier de souscription, dans le cadre de mesures précontractuelles. Vos données peuvent également être utilisées pour évaluer la satisfaction et améliorer l'expérience utilisateur relative aux services proposés sur le site, sur la base de l'intérêt légitime de Acoris.",
    "Enfin, vos données peuvent, avec votre consentement, être utilisées à des fins de prospection commerciale par Acoris, mutuelle soumise au Livre II du Code de la mutualité, immatriculée au répertoire SIRENE sous le n° 417 934 817 ainsi que par ADM Value (ORIAS 521 671 149), mandataire de la Mutuelle Acoris (SIREN 417 934 817).",
    "Lors de la collecte des informations, vous êtes informés du caractère obligatoire ou facultatif des réponses à fournir. La communication des informations obligatoires est requise pour pouvoir utiliser les services proposés par Acoris.",
    "Vos données seront conservées par Acoris le temps nécessaire à l'exécution de ces différentes finalités, ou pour les durées spécifiquement prévues par la CNIL (normes pour le secteur de l'assurance) ou la loi (prescriptions légales).",
    "Les destinataires des données sont, suivant les finalités et dans la limite de leurs attributions : les services compétents de Acoris, l'association souscriptrice, l'organisme de gestion et, le cas échéant, les réassureurs, les fonds de garantie, votre intermédiaire en assurances, ainsi que les tiers habilités appelés à connaître le contrat en raison de sa gestion.",
    "Vos données personnelles peuvent faire l'objet de transferts hors de l'Union Européenne encadrés par des clauses contractuelles conformes aux modèles publiés par l'Union Européenne.",
    "Vous disposez d'un droit d'accès, de rectification, de limitation de traitement, d'opposition au traitement, d'effacement et de portabilité des données vous concernant. Ces requêtes peuvent être adressées à notre Délégué à la protection des données en utilisant l'adresse suivante : dpo@acoris-mutuelles.fr. Vous disposez également du droit d'introduire une réclamation auprès de la CNIL à l'adresse suivante : Commission Nationale Informatique et Libertés – 3 place de Fontenoy, 75007 Paris.",
  ],
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Si paragraphs est fourni, utiliser directement la liste
  // Sinon, utiliser text et le diviser par sauts de ligne doubles
  const displayParagraphs = paragraphs
    ? paragraphs
    : text
      ? text
          .split(/\n\s*\n/)
          .filter((paragraph) => paragraph.trim())
          .map((paragraph) => paragraph.trim())
      : [];

  return (
    <div className="acoris-data-protection">
      <button
        type="button"
        className="acoris-data-protection__header"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="acoris-data-protection__title">{title}</span>
        <span className="acoris-data-protection__toggle">
          <span>Voir {isOpen ? "moins" : "plus"}</span>
          {isOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
        </span>
      </button>
      {isOpen && (
        <div className="acoris-data-protection__content">
          {displayParagraphs.map((paragraph, index, array) => (
            <p
              key={index}
              style={{
                marginBottom: index < array.length - 1 ? "1em" : "0",
              }}
            >
              {paragraph}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default DataProtection;
